<template>
    <div style="position: absolute;left: 0;top: 0;font-family: 'JDZY';width: 100vw;height:100vh ;">
    <div class="lock_top">
        <img :src="logo1" style="" class="logo" alt="" >
        <div class="hright">
        <a  @click="$router.push({name: 'home'})">Home</a>
        <el-radio-group v-model="language" size="mini"  v-if="pmwidth>700">
      <el-radio-button label="EN"></el-radio-button>
      <el-radio-button label="ES"></el-radio-button>
      <el-radio-button label="POR"></el-radio-button>
    </el-radio-group>
    <el-select v-model="language" style="width: 80px;" size="mini" placeholder="请选择" v-if="pmwidth<=700">
    <el-option label="EN" value="EN">
    </el-option>
    <el-option label="ES" value="ES">
    </el-option>
    <el-option label="POR" value="POR">
    </el-option>
  </el-select>
    </div>
    </div>
    <div style="" class="titbox">
    <DIV><h1 class="title" v-if="language=='EN'">{{ lockmsg.titleen}}</h1>
        <h1  class="title" v-if="language=='POR'">{{ lockmsg.titlepor}}</h1>
        <h1  class="title" v-if="language=='ES'">{{ lockmsg.titlees}}</h1></DIV>
    <DIV class="model"><h3>Model:{{ lockmsg.name}}</h3></DIV>
    <div style="" class="gnjs" v-for="(i,l) in gntext" v-if="l<4" >·{{ i }} </div>
</div>
    <div class="cpimg">
            <img :src="lockmsg.img" style="width: 100%;height: 100%;" alt="">
        </div>
        <div class="jscp">
            <div style="margin-top: 10px;position: relative;left: 50%;transform: translateX(-50%);width: auto;text-align: center;"><img v-for="(item,index) in gnlist" v-if="lockmsg.gn.indexOf(index)>=0" style="" class="gnimg"  :src="item" alt=""></div>
            <DIV style="" class="syjs">
        <DIV style="margin-top: 25px;" v-if="language=='EN'" v-for="(item,index) in lockmsg.EN" :key="index">
            {{item}}
            <img src="../../img/tb1_en.png" alt="" srcset="" style="" v-if="$route.params.name=='L98E'">
            <img src="../../img/tb2_en.png" alt="" srcset="" style="" v-if="$route.params.name=='L98A/L98B'">
        </DIV>
        <DIV style="margin-top: 25px;" v-if="language=='POR'" v-for="(item,index) in lockmsg.POR" :key="index">
            {{item}}
            <img src="../../img/tb1_por.png" alt="" srcset="" style="" v-if="$route.params.name=='L98E'">
            <img src="../../img/tb2_por.png" alt="" srcset="" style="" v-if="$route.params.name=='L98A/L98B'">
        </DIV>
        <DIV style="margin-top: 25px;" v-if="language=='ES'" v-for="(item,index) in lockmsg.ES" :key="index">
            {{item}}
            <img src="../../img/tb1_es.png" alt="" srcset="" style="" v-if="$route.params.name=='L98E'">
            <img src="../../img/tb2_es.png" alt="" srcset="" style="" v-if="$route.params.name=='L98A/L98B'">
        </DIV>
    </DIV>
        </div>
    </div>
</template>
<script>
import font from '../../css/font.css'
import logo1 from '../../img/logo1.png'
import tb1 from '../../img/125ico.png'
import tb2 from '../../img/1080ico.png'
import tb3 from '../../img/ctico.png'
import tb4 from '../../img/dcico.png'
import tb5 from '../../img/fhico.png'
import tb6 from '../../img/htico.png'
import tb7 from '../../img/ip65ico.png'
import tb8 from '../../img/jbico.png'
import tb9 from '../../img/ld2ico.png'
import tb10 from '../../img/ldcico.png'
import tb11 from '../../img/ldico.png'
import tb12 from '../../img/lyico.png'
import tb13 from '../../img/mkico.png'
import tb14 from '../../img/mlico.png'
import tb15 from '../../img/mmico.png'
import tb16 from '../../img/myico.png'
import tb17 from '../../img/pdico.png'
import tb18 from '../../img/pmico.png'
import tb19 from '../../img/rlico.png'
import tb20 from '../../img/sdico.png'
import tb21 from '../../img/tynico.png'
import tb22 from '../../img/ydico.png'
import tb23 from '../../img/yjico.png'
import tb24 from '../../img/ysico.png'
import tb25 from '../../img/zwico.png'
import tb26 from '../../img/wifiico.png'
import tb27 from '../../img/clico.png'
export default {
  name: 'lockpage',//门锁页
  data() {
    return{
        pmwidth:document.body.clientWidth,//屏幕宽度
        language:"EN",//语言选择
        gnlist:[tb26,tb1,tb2,tb3,tb4,tb5,tb6,tb7,tb8,tb9,tb10,tb11,tb12,tb13,tb14,tb15,tb16,tb17,tb18,tb19,tb20,tb21,tb22,tb23,tb24,tb25,tb27],//功能的图标
        logo1:logo1,
        gntext:[],//功能的文字列表
        lockmsg:{}//当前锁的基本信息
    }
  },
  mounted () {//实时监控屏幕宽度
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.pmwidth = window.screenWidth
        })()
    }
},
  beforeMount(){
    this.lockmsg.name=this.$route.params.name
 
    let all=this.$store.state.alllockmsg
   
    for(let y of all){
        if(y.name==this.$route.params.name){
       
            this.lockmsg=y
        }
    }
    console.log(this.lockmsg)
    this.gntext=this.lockmsg.gnfont.split('|')
    console.log(this.gntext)
    console.log("欢迎","歡迎","歓迎する","환 영 하 다")
  }
  }
</script>
<style scoped>
.syjs{
    color: #6f6f6f;width: 30rem;margin-top: 2rem;margin-bottom: 5rem;text-align: center;position: relative;left: 50%;transform: translateX(-50%);
}
.syjs img{
    width: 100%;height: 22rem;
}
.gnimg{
    width: 5rem;height: 5rem;
}
.titbox{
    color: #6f6f6f; position: absolute;left: 2rem;top: 50%;width: 39rem; transform: translateY(-50%);height: 20rem;
}
.jscp{
    position: absolute;top: 101vh;width: 10rem;width: 100vw;border-top: 1px solid #878787;padding-top: 10px;
}

.cpimg{
    width: 30rem;height: 30rem;display: inline-block;position: absolute; left: 80%;top:50%;transform: translate(-80%,-50%);
}
.model{
    margin-left: 5rem;
   
}
.model h3{
    font-size: 2rem;
}
.logo{
    width: 6rem; height: 3rem;margin-left: 1.5rem;
}
.lock_top{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10000;
    width: 100vw;
    height: 3rem;
    background-color: rgba(0, 0, 0, 0.8);
}
.hright a{
    font-size: 0.5rem;
    font-weight: bold;
    cursor: pointer;
    color: #FFF;
    margin-right: 10PX;
    margin-left: 1rem;
}
.hright a:hover{
    color: #1e9eb6;
}
.hright{
    float: right;
    margin-right: 20px;
    margin-top: 0.5rem;
}
.title{
    margin-left: 5rem;font-size: 3rem;
}
.gnjs{
    margin-left: 5rem;word-wrap: break-word;width: 20rem;margin-bottom: 0.5rem;
}
@media screen and (max-width: 700px){
    .syjs img{
    width: 100%;height: 70vw;
}
    .syjs{
    color: #6f6f6f;width: 80vw;margin-top: 2rem;margin-bottom: 5rem;text-align: center;position: relative;left: 50%;transform: translateX(-50%);
}
    .gnimg{
    width: 10vw;height: 10vw;
}
    .gnjs{
    margin-left: 1rem;word-wrap: break-word;width: 25vw;font-size: 2vw;
}
    .titbox{
    color: #6f6f6f; display: inline-block; position: relative;left: 0.1rem;top: 20%;width: 40vw; transform: translateY(-20%);height: 20rem;
}
    .jscp{
    position: absolute;top:61vh;width: 10rem;width: 100vw;border-top: 1px solid #878787;padding-top: 10px;
}
    .cpimg{
    width: 50vw;height: 50vw;display: inline-block;position:relative; left: 40vw;top:20%;transform: translate(-40vw,-20%);
}
    .model{
    margin-left: 1rem;
   
}
.model h3{
    font-size: 4vw;
}

    .title{
    margin-left: 1rem;font-size: 5vw;
}
    .logo{
        width: 3rem; height: 1.5rem;margin-left: 0.5rem;margin-top: 1rem;
    }
    .lock_top{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10000;
    width: 100wv;
    height: 3rem;
    background-color: rgba(0, 0, 0, 0.8);
}
.hright a{
    font-size: 0.5rem;
    font-weight: bold;
    cursor: pointer;
    color: #FFF;
    /* margin-right: 10PX; */
    margin-left: 1rem;
}
.hright a:hover{
    color: #1e9eb6;
}
.hright{
    float: right;
    margin-right: 20px;
    margin-top: 0.5rem;
} 
}
</style>